if (!customElements.get("collection-footer")) {
  customElements.define(
    "collection-footer",
    class CollectionFooter extends HTMLElement {
      constructor() {
        super();
        this.init();
        this.querySelector(".collection-footer__more span").addEventListener(
          "click",
          this.onCLick.bind(this)
        );
      }

      init() {
        if (this.clientHeight > 500) {
          this.classList.toggle("active");
          this.querySelector(".collection-footer__more").classList.toggle(
            "hidden"
          );
        }
      }

      onCLick() {
        this.classList.toggle("active");
        this.querySelector(".collection-footer__more").classList.toggle(
          "hidden"
        );
      }
    }
  );
}
